export default "e10381430328972a.svg"